import React from 'react';

export const InfoIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM10.875 10.5H12C12.4148 10.5 12.75 10.8352 12.75 11.25V16.125C12.75 16.3312 12.9188 16.5 13.125 16.5H13.5M12.1875 8.25C12.1875 8.56066 11.9357 8.8125 11.625 8.8125C11.3143 8.8125 11.0625 8.56066 11.0625 8.25C11.0625 7.93934 11.3143 7.6875 11.625 7.6875C11.9357 7.6875 12.1875 7.93934 12.1875 8.25Z"
      stroke="#455468"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ArrowUpRightIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.375 2.625H11.375V9.625M11.375 2.625L2.625 11.375"
      stroke="#455468"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const TrashIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.8125 3.5H2.1875M5.6875 6.125V9.625M8.3125 6.125V9.625M10.9375 3.5V11.375C10.9375 11.6166 10.8416 11.8483 10.6699 12.0199C10.4983 12.1916 10.2666 12.2875 10.025 12.2875H3.975C3.7334 12.2875 3.50172 12.1916 3.33012 12.0199C3.15853 11.8483 3.0625 11.6166 3.0625 11.375V3.5M9.1875 3.5V2.625C9.1875 2.3834 9.09147 2.15172 8.91988 1.98012C8.74828 1.80853 8.5166 1.7125 8.275 1.7125H5.725C5.4834 1.7125 5.25172 1.80853 5.08012 1.98012C4.90853 2.15172 4.8125 2.3834 4.8125 2.625V3.5"
      stroke="#FF3838"
      strokeWidth="1.3125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
